import { Component, Input } from '@angular/core';

/**
 * Graue Kacheln an der Stelle, an der gleich Fotos stehen.
 *
 * Solange die Liste laedt, war die Seite leer — und sprang mit der Antwort in
 * ihre Form. Die Platzhalter nehmen dieselbe Anordnung vorweg wie
 * `app-virtual-photo-grid`: gleiche Mindestbreite, gleicher Abstand, gleiches
 * Seitenverhaeltnis. Deshalb dieselben Eingaben mit denselben Namen.
 *
 * Die Spalten rechnet hier das CSS (`auto-fill`), nicht JavaScript wie im
 * echten Raster: fuer ein Dutzend feste Kacheln braucht es kein virtuelles
 * Scrollen, und so steht das Skelett mit dem ersten Bild der Seite.
 */
@Component({
  selector: 'app-photo-grid-skeleton',
  templateUrl: './photo-grid-skeleton.component.html',
  styleUrl: './photo-grid-skeleton.component.scss',
  host: {
    'aria-hidden': 'true',
    '[style.--skel-min.px]': 'minTileWidth',
    '[style.--skel-min-wide.px]': 'minTileWidthWide ?? minTileWidth',
    '[style.--skel-gap.px]': 'gap',
    '[style.--skel-ratio]': 'aspectRatio',
  },
})
export class PhotoGridSkeletonComponent {
  @Input() minTileWidth = 115;
  @Input() minTileWidthWide?: number;
  @Input() gap = 4;
  @Input() aspectRatio = 1;
  @Input() set count(n: number) { this.cells = Array.from({ length: n }, (_, i) => i); }

  cells = Array.from({ length: 18 }, (_, i) => i);
}
